export const RUNTIME_CONFIG = Object.freeze({
  physicsHz: 60,
  minimumPixelRatio: 0.6,
  maximumPixelRatio: 1,
  targetFramesPerSecond: 60,
});
